import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore('properties', storeModule.createStoreModule('properties'))
